// extracted by mini-css-extract-plugin
module.exports = {"legendWrapper":"CustomLegend_legendWrapper__2COb6","legendItem":"CustomLegend_legendItem__2KHDe","legendItemIcon":"CustomLegend_legendItemIcon__2izxS"};